import MaterialUITable from "../../../common-utilities/core/material-ui-table";
import MuiTable from "../../../common-utilities/core/mui-table";
import { getManageDistributionCenterHeaderConfig } from "./config";

const ManageDistributionCenterTable = ({
  users,
  filters,
  setFilters,
  loadData,
  getData,
}) => {
  return (
    <>
      <MuiTable
        columnsList={getManageDistributionCenterHeaderConfig()}
        dataList={users.results || []}
        filters={filters}
        pageCount={users.totalPages || 0}
        onClick={loadData}
        onChange={(page) => {
          setFilters({
            ...filters,
            page,
          });
          getData(
            {
              ...filters,
              page,
            },
            true,
            1
          );
        }}
      ></MuiTable>
      {/* <MaterialUITable
        columnsList={getManageDistributionCenterHeaderConfig()}
        dataList={users.results || []}
        pageCount={users.totalPages || 0}
        filters={filters}
        onChange={(event, page) => {
          setFilters({
            ...filters,
            page,
          });
          getData(
            {
              ...filters,
              page,
            },
            true,
            1
          );
        }}
        onClick={loadData}
      /> */}
    </>
  );
};

export default ManageDistributionCenterTable;
